export enum LingoRouteName {
	HOME = 'Play',
	CLAIM = 'Claim',
	STAKING = 'Staking',
	STAKING_UPGRADE = 'StakingUpgrade',
	STAKING_CLAIM = 'StakingClaim',
	STAKING_NEW = 'StakingNew',
	REWARDS = 'Rewards',
	BUY = 'Buy',
	BRIDGE = 'Bridge',
	REFERRALS = 'Referrals',
	ADMIN_TOOLS = 'AdminTools',
	CLAIM_WIZARD = 'ClaimWizard',
	CLAIM_CONFIRM = 'ClaimConfirm',
	FAQ = 'FAQ',
	TERMS_OF_SERVICE = 'TermsOfService',
	PRIVACY_POLICY = 'PrivacyPolicy',
}

export const lingoRoutePath: Record<LingoRouteName, string> = {
  [LingoRouteName.HOME]: '/',
  [LingoRouteName.CLAIM]: '/claim',
  [LingoRouteName.CLAIM_WIZARD]: '/claim/wizard',
  [LingoRouteName.CLAIM_CONFIRM]: '/claim/confirm',
  [LingoRouteName.STAKING]: '/staking',
  [LingoRouteName.STAKING_NEW]: '/staking/new',
  [LingoRouteName.STAKING_UPGRADE]: '/staking/upgrade/:id',
  [LingoRouteName.STAKING_CLAIM]: '/staking/claim/:id',
  [LingoRouteName.REWARDS]: '/rewards',
  [LingoRouteName.BUY]: '/buy',
  [LingoRouteName.BRIDGE]: '/bridge',
  [LingoRouteName.REFERRALS]: '/referrals',
  [LingoRouteName.ADMIN_TOOLS]: '/admin-tools',
  [LingoRouteName.FAQ]: '/faq',
  [LingoRouteName.TERMS_OF_SERVICE]: '/terms-of-service',
  [LingoRouteName.PRIVACY_POLICY]: '/privacy-policy',
}
